/*
 *
 * App reducer
 *
 */

import { ActionType } from 'typesafe-actions';
import ActionTypes from '../constants/history';
import ActionTypesCabinet from 'containers/Configurator/constants/furniture';
import * as actions from '../actions/history';
import { HistoryState, HistoryStep } from './../types';

type HistoryActions = ActionType<typeof actions>;

export const initialState: HistoryState = {
  indice: 0,
  steps: [],
};

function reducer(
  state: HistoryState = initialState,
  action: any,
): HistoryState {
  switch (action.type) {
    case ActionTypes.HISTORY_UNDO_SUCCESS:
    case ActionTypes.HISTORY_REDO_SUCCESS:
      return { ...state, indice: action.payload.indice };
    case ActionTypesCabinet.CABINET_UPDATE_SUCCESS:
      if (!action.payload.preview || !action.payload.history) {
        // Add the cabinet to history
        const steps = [...state.steps];
        if (state.indice !== state.steps.length - 1) {
          steps.splice(state.indice + 1);
        }
        const currentStep: HistoryStep = {
          furniture: action.payload.furniture,
          selectedId: action.payload.selectedId,
          message: action.payload.message,
        };
        steps.push(currentStep);
        return {
          indice: steps.length - 1,
          steps: steps,
        };
      }
      return state;
    case ActionTypesCabinet.FURNITURE_SELECT_FROMID_CABINET:
      // Set the selected ID to the history
      const steps = [...state.steps];
      if (state.indice !== state.steps.length - 1) {
        steps.splice(state.indice + 1);
      }
      const currentStep: HistoryStep = {
        furniture: state.steps[state.indice].furniture,
        selectedId: action.payload.id,
        message: null,
      };
      steps.push(currentStep);
      return {
        indice: steps.length - 1,
        steps: steps,
      };
    case ActionTypesCabinet.FURNITURE_LOAD_SUCCESS:
      let selectedId: string | null = null;
      if (action.payload.furniture.quantity > 1) {
        selectedId = null;
      } else {
        selectedId = action.payload.furniture.getByOrder(0).id;
      }
      return {
        ...state,
        indice: 0,
        steps: [
          {
            furniture: action.payload.furniture,
            message: null,
            selectedId: selectedId,
          } as HistoryStep,
        ],
      };
    default:
      return state;
  }
}

export default reducer;
